import { api } from './authService';

/**
 * @description Obtiene la lista de todas las órdenes de trabajo desde la API.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la lista de órdenes de trabajo.
 */
const getWorkOrders = (params = {}) => {
  return api.get('/work-orders', { params });
};

/**
 * @description Obtiene una orden de trabajo específica por su ID.
 * @param {string | number} id El ID de la orden de trabajo.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con los datos de la orden de trabajo.
 */
const getWorkOrder = (id) => {
  return api.get(`/work-orders/${id}`);
};

/**
 * @description Envía los datos de una nueva orden de trabajo a la API para su creación.
 * @param {object} workOrderData Los datos de la orden de trabajo a crear.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden de trabajo creada.
 */
const createWorkOrder = (workOrderData) => {
  return api.post('/work-orders', workOrderData);
};

/**
 * @description Actualiza una orden de trabajo existente en la API.
 * @param {string | number} id El ID de la orden de trabajo a actualizar.
 * @param {object} workOrderData Los nuevos datos para la orden de trabajo.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden de trabajo actualizada.
 */
const updateWorkOrder = (id, workOrderData) => {
  return api.patch(`/work-orders/${id}`, workOrderData);
};

/**
 * @description Elimina una orden de trabajo existente de la API.
 * @param {string | number} id El ID de la orden de trabajo a eliminar.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API.
 */
const deleteWorkOrder = (id) => {
  return api.delete(`/work-orders/${id}`);
};

const workOrderService = {
  getWorkOrders,
  getWorkOrder,
  createWorkOrder,
  updateWorkOrder,
  deleteWorkOrder,
};

export default workOrderService;
